module.exports = __webpack_public_path__ + "static/img/catch_map.f19e9a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/catch_map.png
// module id = JbqW
// module chunks = 6